import React, { useEffect, useState, useRef } from 'react';
import {
  AiOutlinePlusCircle,
  AiOutlineDelete,
  AiOutlineEdit, AiOutlineCheck, AiOutlineClose
} from 'react-icons/ai';
import Select from 'react-select';
import axios from 'axios';
import { Modal, Button, Table, Form } from "react-bootstrap";
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from 'react-icons/ci';
import { MdLocalPrintshop } from "react-icons/md";
import logo from '../../../assets/logo.png'
import { useLocation } from 'react-router-dom';
import { useLoading } from '../../../context/LoadingContext';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import socket from "../../../socket";

const Complaint = ({ adminData, branchID, financialYear }) => {




  // ========================useStates=========================
  const location = useLocation();
  const mode = location.state?.mode;
  const partyId = location.state?.partyId;

  const editData = location.state?.data;


  useEffect(() => {
    if (mode === "edit" && editData) {
      handleEdit(editData);
    }
  }, [editData, mode]);


  const navigate = useNavigate();
  const { showAddForm, partyData } = location.state || {};

  useEffect(() => {
    if (mode === "showForm" && partyId) {
      setEditId(partyId);
      setShowForm(true)
      fetchComplaintById(partyId);

    }
  }, [mode, partyId]);

  useEffect(() => {
    if (partyData) {
      setFormData(prev => ({
        ...prev,
        party: partyData.party || "",
        site: partyData.site || "",
        contact_no: partyData.contact_no || "",
        partyid: partyData.partyid || ""
      }));
    }
  }, [partyData]);




  const { setLoading } = useLoading();
  const [complaintList, setComplaintList] = useState([]);
  const [partyOptions, setPartyOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [showPartyModal, setShowPartyModal] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const fileInputRef = useRef(null);
   const searchInputRef = useRef(null);

  const [inventoryItems, setInventoryItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [editId, setEditId] = useState(null);
  const [selectedPrint, setSelectedPrint] = useState(null);


  const [showForm, setShowForm] = useState(location.state?.showAddForm || false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [historyItems, setHistoryItems] = useState([]);
  const [callList, setCallList] = useState([]);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [loadingHistory, setLoadingHistory] = useState(false);
  const [serialsByItem, setSerialsByItem] = useState({});
  const [serialError, setSerialError] = useState({});
  const [subTotal, setSubTotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [newRemark, setNewRemark] = useState("");
  const [detailItems, setDetailItems] = useState([
    { item: null, quantity: "", sr_no: "", technician: null }
  ]);
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [branchDetail, setBranchDetail] = useState([])
  const [address, setAddress] = useState({});
  const [previewRemark, setPreviewRemark] = useState("");
  const [showPreview, setShowPreview] = useState(false);


  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });


  const [offset, setOffset] = useState(0);
  const limit = 20;
  const [hasMore, setHasMore] = useState(true);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [isLocked, setIsLocked] = useState(false);
  const [fy, setFy] = useState([]);
const [complaintUnread, setComplaintUnread] = useState(0);

  const [financialRange, setFinancialRange] = useState({
    from_date: '',
    to_date: ''
  });



useEffect(() => {
  if (showPartyModal) {
    setTimeout(() => {
      searchInputRef.current?.focus();
    }, 100);
  }
}, [showPartyModal]);

  const getCurrentDateTime = () => {
    const now = new Date();

    const istOffset = 5.5 * 60;
    const localOffset = now.getTimezoneOffset();
    const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);

    const year = istTime.getFullYear();
    const month = String(istTime.getMonth() + 1).padStart(2, "0");
    const day = String(istTime.getDate()).padStart(2, "0");
    const hours = String(istTime.getHours()).padStart(2, "0");
    const minutes = String(istTime.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    complaintType: "",
    party: "",
    site: "",
    contact_no: "",
    date: getCurrentDateTime(),
    franchisee_cost: "",
    description: "",
    remarks: "",
    source: "",
    status: "",
    items: [
      {
        item: null, qty: '', install: "", sr_no: [],
        details: [

          {
            item: null,
            quantity: 1,
            sr_no: "",
            technician: null
          }
        ]

      }
    ],
    attachments: [],
    partyid: "",
    approval_status: "Pending",
    visits: [
      {
        technician: null,
        assignedDate: "",
        visitDate: "",
        visitOutDate: '',
        inLocation: "",
        outLocation: '',

        remark: "",
        status: null,
        status_type: 'complaint',

        tech_db_id: '',
      }
    ],
    customer_remark: '',
    call_status: '',
  });

  const [sourceOptions, setSourceOptions] = useState([
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" }
  ]);

  const [statusOptions, setStatusOptions] = useState([
    { value: "APPOINTMENT", label: "APPOINTMENT" },
    { value: "Closed CMP", label: "Closed CMP" },
    { value: "COMPLETED OC", label: "COMPLETED OC" },
    { value: "FAILED", label: "FAILED" },
    { value: "IN FALLOWUP", label: "IN FALLOWUP" },
    { value: "OPEN CMP", label: "OPEN CMP" },
    { value: "Passed PMS", label: "Passed PMS" },
    { value: "RE-COMPLAINT", label: "RE-COMPLAINT" },
    { value: "VALUE", label: "VALUE" }
  ]);

  const [showOptionModal, setShowOptionModal] = useState(false);
  const [newOptionValue, setNewOptionValue] = useState("");
  const [activeDropdown, setActiveDropdown] = useState("");

useEffect(() => {
  if (!branchDetail?.code) return;

  socket.on("new-call", (data) => {

    if (data.branch === branchDetail.code) {
      showToast(data.message, "info");
    }
  });

  return () => socket.off("new-call");
}, [branchDetail]); 


//for tech assigned 




useEffect(() => {
  if (!adminData.user.emp_id) return;

  socket.on("connect", () => {
    // console.log("Connected:", socket.id);

    socket.emit("register-user", adminData.user.emp_id);
    // console.log("Registered:", adminData.user.emp_id);
  });

  // If already connected
  if (socket.connected) {
    socket.emit("register-user", adminData.user.emp_id);
    // console.log("Registered:", adminData.user.emp_id);
  }

  return () => {
    socket.off("connect");
  };
}, [adminData.user.emp_id]);


useEffect(() => {
  const handleAssignedCall = (data) => {
    // console.log("🔥 NEW ASSIGNED CALL RECEIVED:", data);

    showToast(data.message, "info");
  };

  socket.on("new-assigned-call", handleAssignedCall);

  return () => {
    socket.off("new-assigned-call", handleAssignedCall);
  };
}, []);


  const handlePrint = (data) => {
    setSelectedPrint(data);

    setTimeout(() => {
      const printContents = document.getElementById("print-area").innerHTML;
      let printWindow = window.open("", "_blank", "width=900,height=700");

      printWindow.document.write(`
      <html>
        <head>
          <title>Print Complaint</title>
          <style>
            body { font-family: Arial; padding: 20px; }
          </style>
        </head>
        <body>${printContents}</body>
      </html>
    `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    }, 300);
  };


  const handleFormOpen = () => {
    setShowForm(true);
  }

  const showToast = (message, bg = 'success') => {
    setToast({ show: true, message, bg });
  };

  const addRow = () => {
    setFormData(prev => ({
      ...prev,
      items: [...prev.items, { item: "", installed_in: "" }]
    }));
  };

  const deleteRow = (index) => {
    setFormData(prev => ({
      ...prev,
      items: prev.items.filter((_, i) => i !== index)
    }));
  };


  // const filtered = partyOptions.filter(
  //   (p) =>
  //     p.label.toLowerCase().includes(search.toLowerCase()) ||
  //     p.phoneList.some((ph) =>
  //       ph.toLowerCase().includes(search.toLowerCase())
  //     ) ||
  //     (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
  // );

  const searchValue = (search || "").toLowerCase();

  const filtered = partyOptions.filter((p) => {
    const labelMatch =
      p?.label?.toLowerCase().includes(searchValue);

    const phoneMatch =
      Array.isArray(p?.phoneList) &&
      p.phoneList.some(
        (ph) => ph?.toLowerCase().includes(searchValue)
      );

    const addressMatch =
      p?.address?.toLowerCase().includes(searchValue);

    return labelMatch || phoneMatch || addressMatch;
  });

  const limitText = (text, limit) => {
    if (!text) return "";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const handleOpenHistory = () => {
    setShowHistoryModal(true);
    // fetchHistory();
  };

  const updateDetailRow = (index, field, value) => {
    const newDetailItems = [...detailItems];

    if (field === "item") {
      newDetailItems[index].item = value;
      newDetailItems[index].sr_no = value.sr_no;
      newDetailItems[index].quantity = 1;
    } else {
      newDetailItems[index][field] = value;
    }

    setDetailItems(newDetailItems);
  };


  const updateItemRow = (index, field, value) => {
    setFormData(prev => {
      const updated = [...prev.items];
      updated[index] = {
        ...updated[index],
        [field]: value
      };

      const itemId = updated[index].item;
      const qty = updated[index].qty || 0;

      if (itemId && qty > 0 && ["item", "qty"].includes(field)) {

        fetchSerials(itemId, qty);
      }



      return { ...prev, items: updated };
    });
  };

  const getSerialNumbers = (inventory_id, qty) => {
    if (!inventory_id || !qty) return [];
    const list = serialsByItem[inventory_id] || [];
    return list.slice(0, qty).map(s => s.sr_no);
  };


  const addVisitRow = () => {
    setFormData(prev => ({
      ...prev,
      visits: [
        ...prev.visits,
        {
          technician: null,
          assignedDate: "",
          visitDate: "",
          visitOutDate: '',
          inLocation: "",
          outLocation: '',
          location: "",
          remark: "",
          status: null
        }
      ]
    }));
  };





  const updateVisitRow = (index, field, value) => {
    setFormData(prev => {
      const updatedVisits = [...prev.visits];
      updatedVisits[index][field] = value;

      return {
        ...prev,
        visits: updatedVisits
      };
    });
  };



  // Add a new row
  const addDetailRow = () => {
    setDetailItems(prev => [...prev, { item: null, quantity: 1, sr_no: "", technician: null }]);
  };

  // Delete a row
  const deleteDetailRow = (index) => {
    setDetailItems(prev => prev.filter((_, i) => i !== index));
  };


  const getAddressFromLatLng = async (lat, lng) => {
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );
      const data = await res.json();

      if (!data || !data.address) return "";

      const {
        suburb,
        city,
        town,
        village,
        county,
        state,
        postcode
      } = data.address;


      const cityName = city || town || village || "";


      return [
        suburb,
        cityName,
        county,
        state,
        postcode
      ]
        .filter(Boolean)
        .join(", ");

    } catch (err) {
      console.error("Reverse geocode failed:", err);
      return "";
    }
  };


  const parseLatLng = (val) => {
    if (!val) return null;


    if (typeof val === "string" && val.startsWith("[")) {
      try {
        const arr = JSON.parse(val);
        if (
          Array.isArray(arr) &&
          arr.length === 2 &&
          !isNaN(arr[0]) &&
          !isNaN(arr[1])
        ) {
          return { lat: Number(arr[0]), lng: Number(arr[1]) };
        }
      } catch {
        return null;
      }
    }


    if (typeof val === "string" && val.includes(",")) {
      const [lat, lng] = val.split(",").map(v => Number(v.trim()));
      if (!isNaN(lat) && !isNaN(lng)) {
        return { lat, lng };
      }
    }

    return null;
  };



  const handleEdit = async (data) => {

    console.log(data, 'in edit mode ')

    setEditId(data.id);
    setNewRemark("");

    const parsedItems = (JSON.parse(data.items || "[]") || []).map(item => {
      let combinedDetails = [];

      if (Array.isArray(data.technicians)) {
        data.technicians.forEach(tech => {
          if (tech.item_details) {
            const techDetails = typeof tech.item_details === "string"
              ? JSON.parse(tech.item_details)
              : tech.item_details;

            const matchingDetails = (techDetails || []).filter(
              d => Number(d.model_id) == Number(item.id)
            ).map(d => ({
              ...d,
              technician_id: tech.technician_id
            }));

            combinedDetails = combinedDetails.concat(matchingDetails);
          }
        });
      }


      const mappedDetails = combinedDetails.map(d => ({
        item: d.item_id,
        item_name: d.name,
        quantity: d.qty || d.quantity || 1,
        sr_no: Array.isArray(d.sr_no) ? d.sr_no.join(", ") : d.sr_no || "",
        technician: d.technician_id
      }));

      return {
        item: item.id,
        qty: item.qty,
        install: item.install,
        details: mappedDetails
      };
    });

    parsedItems.forEach(it => {
      if (it.id && it.qty > 0) fetchSerials(it.id, it.qty);
    });

    let parsedVisits = [];

    try {
      if (typeof data.visits === "string") {
        parsedVisits = JSON.parse(data.visits);
        if (!Array.isArray(parsedVisits)) parsedVisits = [];
      } else if (Array.isArray(data.visits)) {
        parsedVisits = data.visits;
      }
    } catch (err) {
      console.warn("Invalid visits JSON, defaulting to empty array:", data.visits);
      parsedVisits = [];
    }


    const editVisits = [];

    if (Array.isArray(data.technicians)) {

      const visitsWithAddress = await Promise.all(
        data.technicians.map(async (t) => {
          let inLocation = t.inLocation || "";
          let outLocation = t.outLocation || "";
          const inCoords = parseLatLng(inLocation);
          if (inCoords) {
            inLocation = await getAddressFromLatLng(inCoords.lat, inCoords.lng);
          }

          const outCoords = parseLatLng(outLocation);
          if (outCoords) {
            outLocation = await getAddressFromLatLng(outCoords.lat, outCoords.lng);
          }

          return {
            id: t.id || null,
            technician:
              employeeOptions.find(e => e.value === t.technician_id) || {
                value: t.technician_id,
                label: t.technician_id
              },
            assignedDate: t.assignedDate || "",
            visitDate: t.visitDate || "",
            visitOutDate: t.visitOutDate || "",
            inLocation,
            outLocation,
            remark: t.remark || "",
            status:
              statusOptions.find(
                s => s.value === t.status || s.label === t.status
              ) || null,
            status_type: t.status_type || "complaint",

            // tech_db_id:t.tech_db_id|| "",
            // tech_db_id: employeeOptions.find(e => e.value === t.technician_id)?.id || "",
          };
        })
      );

      editVisits.push(...visitsWithAddress);
    }


    // === TECHNICIAN HISTORY ===
    let allHistoryItems = [];

    if (Array.isArray(data.technicians)) {
      data.technicians.forEach(tech => {
        if (tech.item_details) {
          const techDetails = typeof tech.item_details === "string"
            ? JSON.parse(tech.item_details)
            : tech.item_details;

          const mappedHistory = (techDetails || []).map(d => ({
            date: tech.visitDate || "",
            model_name: d.name || "",
            sub_item: d.name || "",
            quantity: d.qty || d.quantity,
            technician: tech.technician_id,
            sr_no: Array.isArray(d.sr_no) ? d.sr_no.join(", ") : d.sr_no || ""
          }));

          allHistoryItems = allHistoryItems.concat(mappedHistory);
        }
      });
    }

    setHistoryItems(allHistoryItems);

    const parsedAttachments = JSON.parse(data.attachments || "[]");


    const allPhones = [
      data.party_phone,
      data.party_phone2,
      data.party_phone3,
      data.party_phone4
    ]
      .filter(p => p && p.trim() !== "")
      .join(", ");


    setFormData(prev => ({
      ...prev,
      id: data.id,
      branch: data.branch,
      complaintType: data.complaintType || "",
      party: data.party_name || "",
      partyid: data.partyid || "",
      site: data.party_address || "",
      contact_no: allPhones || "",
      date: data.date || "",
      franchisee_cost: data.franchisee_cost || "",
      description: data.description || "",
      remarks: data.remarks || "",
      source: data.source?.trim() || "",
      status: data.status?.trim() || "",
      items: parsedItems,
      customer_remark: data.customer_remark || "",
      attachments: parsedAttachments,
      // visits: editVisits.length ? editVisits : prev.visits
      visits: editVisits.length ? editVisits : [],

      call_status: data.call_status || ""
    }));

    setDetailItems(parsedItems[0]?.details || []);
    setAttachments(parsedAttachments);
    setShowForm(true);
  };


  const EMPTY_VISIT = {
    id: null,
    technician: null,
    assignedDate: "",
    visitDate: "",
    visitOutDate: "",
    inLocation: "",
    outLocation: "",
    remark: "",
    status: null,
    tech_db_id: ''
  };

  const INITIAL_FORM_DATA = {
    complaintType: "",
    party: "",
    site: "",
    contact_no: "",
    date: getCurrentDateTime(),
    franchisee_cost: "",
    description: "",
    remarks: "",
    source: "",
    customer_remark: "",
    status: "",
    items: [
      {
        item: null,
        install: "",
        sr_no: "",
        details: [
          {
            item: null,
            quantity: 1,
            sr_no: "",
            technician: null
          }
        ]
      }
    ],
    attachments: [],
    partyid: "",
    approval_status: "Pending",
    visits: [{ ...EMPTY_VISIT }]
  };


  const resetForm = () => {
    setEditId(null);
    setShowForm(false);
    setNewRemark("");

    // 🔥 important: new object reference
    setFormData({ ...INITIAL_FORM_DATA });

    setAttachments([]);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const form = new FormData();
      const safe = (v) => (v === undefined || v === null ? "" : v);

      Object.entries({
        complaintType: formData.complaintType,
        partyid: formData.partyid,
        date: formData.date,
        franchisee_cost: formData.franchisee_cost,
        description: formData.description,
        // remarks: formData.remarks,
        source: formData.source,
        status: formData.status,
        ref_doc: formData.ref_doc
      }).forEach(([key, value]) => form.append(key, value));

      if (newRemark?.trim()) {
        const remarkPayload = {
          remarks: newRemark.trim(),
          adminId: adminData.user.id,
          date: new Date().toISOString()
        };

        form.append("remarks", JSON.stringify(remarkPayload));
      }

      const itemsPayload = formData.items
        .filter(it => it.item && Number(it.qty) > 0)
        .map(it => {
          const item = inventoryOptions.find(o => o.value === it.item);

          return {
            id: item.value,
            name: item.label,
            qty: Number(it.qty),
            rate: Number(item.rate),
            gst: item.gst,
            tax: item.tax,
            hsn:item.hsn,
            amount: Number(it.qty) * Number(item.rate),
            install: it.install,
            sr_no: getSerialNumbers(it.item, it.qty),

            // ✅ FIXED DETAILS
            details: (it.details || []).map(d => ({
              item_id: d.item?.value ?? null,
              name: d.item?.label ?? null,
              quantity: Number(d.quantity) || 1,
              sr_no: d.sr_no || "",
              technician_id: d.technician?.value || null
            }))
          };
        });


      form.append("items", JSON.stringify(itemsPayload));



      const mapStatusToCallStatus = (status) => {
        return status === "COMPLETED OC" ? "completed" : "new";
      };





      // if (formData.status === "COMPLETED OC") {
      //   form.append("call_status", "completed");
      // } else if (editId) {

      //   form.append("call_status", formData.call_status);
      // //  form.append("call_status", "new");
      // }


      if (formData.status === "COMPLETED OC") {

        form.append("call_status", "completed");
      } else if (editId) {

        form.append("call_status", formData.call_status);
      } else {

        form.append("call_status", "new");
      }

      // NEW FILES ONLY
      attachments.forEach((att, index) => {
        form.append("files", att.file);
        form.append(`file_remarks_${index}`, att.remark);
      });


      // ===== VISITS =====
      const formattedVisits = (formData.visits || []).map((v, idx) => {
        const visit = {
          technician_id: v.technician?.value || null,
          assignedDate: safe(v.assignedDate),
          visitDate: safe(v.visitDate),
          visitOutDate: safe(v.visitOutDate),
          inLocation: safe(v.inLocation),
          outLocation: safe(v.outLocation),
          remark: safe(v.remark),
          status: v.status,
          status_type: v.status_type || 'complaint',
          tech_db_id: v.technician?.id || null,
          //  tech_db_id: selectedEmp?.id || null,
        };

        return visit;
      });

      form.append("visits", JSON.stringify(formattedVisits));
      form.append("customer_remark", formData.customer_remark);
      form.append('branch', branchDetail.code)





      if (editId) {

        form.append("oldAttachments", JSON.stringify(formData.attachments));

        form.append("id", editId);
        form.append("edit_by", adminData.user.id);

        await axios.put("https://api.skyguard.group/api/update-complaint", form, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        showToast("Complaint Updated Successfully", "success");
      }
      else {
        form.append("added_by", adminData.user.id);
        const res = await axios.post("https://api.skyguard.group/api/add-complaint", form, {
          headers: { "Content-Type": "multipart/form-data" }
        });

        setComplaintList(prev => [
          ...prev,
          { id: res.data.insertId, ...formData }
        ]);

        showToast("Complaint Added Successfully", "success");
      }

      resetForm();
      fetchComplaints(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
      setAttachments([]);

      setNewRemark("");
    } catch (error) {
      console.error(error);
      showToast("Error occurred", "danger");
    }
  };


  const filteredData = callList.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )


  const remarkTableData = callList
    .filter(pms => pms.id === editId)
    .flatMap(pms => {
      let remarksArray = [];

      try {
        remarksArray = Array.isArray(pms.remark_history)
          ? pms.remark_history
          : JSON.parse(pms.remark_history || "[]");
      } catch {
        remarksArray = [];
      }

      return remarksArray.map(r => {
        let adminName = "Unknown";

        // match with added_by
        if (r.adminId === pms.added_id) {
          adminName = [
            pms.added_name,
            pms.added_name_middle,
            pms.added_name_last
          ].filter(Boolean).join(" ");
        }

        // match with edit_by
        else if (r.adminId === pms.edit_id) {
          adminName = [
            pms.edit_name,
            pms.edit_name_middle,
            pms.edit_name_last
          ].filter(Boolean).join(" ");
        }

        return {
          adminId: r.adminId,
          adminName,
          remark: r.remarks,
          date: r.date,
          pmsId: pms.id
        };
      });
    });



  const fetchComplaintById = async (id) => {
    try {
      const res = await axios.get(
        `https://api.skyguard.group/api/fetch-complaintId/${id}`
      );

      const data = res.data;

      console.log("Complaint Data:", data);

      setNewRemark("");



      const parsedItems = (JSON.parse(data.items || "[]") || []).map(item => {
        let combinedDetails = [];

        if (Array.isArray(data.technicians)) {
          data.technicians.forEach(tech => {
            if (tech.item_details) {
              const techDetails =
                typeof tech.item_details === "string"
                  ? JSON.parse(tech.item_details)
                  : tech.item_details;

              const matchingDetails = (techDetails || [])
                .filter(d => Number(d.model_id) === Number(item.id))
                .map(d => ({
                  ...d,
                  technician_id: tech.technician_id
                }));

              combinedDetails = combinedDetails.concat(matchingDetails);
            }
          });
        }

        const mappedDetails = combinedDetails.map(d => ({
          item: d.item_id
            ? inventoryOptions.find(opt => opt.value === d.item_id) || {
              value: d.item_id,
              label: d.name
            }
            : null,
          quantity: d.qty || d.quantity || 1,
          sr_no: Array.isArray(d.sr_no)
            ? d.sr_no.join(", ")
            : d.sr_no || "",
          technician: d.technician_id
            ? employeeOptions.find(opt => opt.value === d.technician_id) || {
              value: d.technician_id,
              label: d.technician_id
            }
            : null
        }));

        return {
          item: item.id,
          qty: item.qty,
          install: item.install,
          details: mappedDetails
        };
      });


      let editVisits = [];

      if (Array.isArray(data.technicians)) {
        const visitsWithAddress = await Promise.all(
          data.technicians.map(async (t) => {
            let inLocation = t.inLocation || "";
            let outLocation = t.outLocation || "";

            const inCoords = parseLatLng(inLocation);
            if (inCoords) {
              inLocation = await getAddressFromLatLng(
                inCoords.lat,
                inCoords.lng
              );
            }

            const outCoords = parseLatLng(outLocation);
            if (outCoords) {
              outLocation = await getAddressFromLatLng(
                outCoords.lat,
                outCoords.lng
              );
            }

            return {
              id: t.id || null,
              technician:
                employeeOptions.find(e => e.value === t.technician_id) || {
                  value: t.technician_id,
                  label: t.technician_id
                },
              assignedDate: t.assignedDate || "",
              visitDate: t.visitDate || "",
              visitOutDate: t.visitOutDate || "",
              inLocation,
              outLocation,
              remark: t.remark || "",
              status:
                statusOptions.find(
                  s => s.value === t.status || s.label === t.status
                ) || null,
              status_type: t.status_type || "complaint",

              // tech_db_id:t.tech_db_id || '',

              // tech_db_id: employeeOptions.find(e => e.value === t.technician_id)?.id || '',
            };
          })
        );

        editVisits.push(...visitsWithAddress);
      }



      let allHistoryItems = [];

      if (Array.isArray(data.technicians)) {
        data.technicians.forEach(tech => {
          if (tech.item_details) {
            const techDetails =
              typeof tech.item_details === "string"
                ? JSON.parse(tech.item_details)
                : tech.item_details;

            const mappedHistory = (techDetails || []).map(d => ({
              date: tech.visitDate || "",
              model_name: d.name || "",
              sub_item: d.name || "",
              quantity: d.qty || d.quantity,
              technician: tech.technician_id,
              sr_no: Array.isArray(d.sr_no)
                ? d.sr_no.join(", ")
                : d.sr_no || ""
            }));

            allHistoryItems = allHistoryItems.concat(mappedHistory);
          }
        });
      }

      setHistoryItems(allHistoryItems);

      const parsedAttachments = JSON.parse(data.attachments || "[]");


      const allPhones = [
        data.party_phone,
        data.party_phone2,
        data.party_phone3,
        data.party_phone4
      ]
        .filter(p => p && p.trim() !== "")
        .join(", ");

      setFormData(prev => ({
        ...prev,
        id: data.id,
        complaintType: data.complaintType || "",
        party: data.party_name || "",
        partyid: data.partyid || "",
        site: data.party_address || "",
        contact_no: allPhones || "",
        date: data.date || "",
        franchisee_cost: data.franchisee_cost || "",
        description: data.description || "",
        remarks: data.remarks || "",
        source: data.source?.trim() || "",
        status: data.status?.trim() || "",
        items: parsedItems,
        customer_remark: data.customer_remark || "",
        attachments: parsedAttachments,
        visits: editVisits.length ? editVisits : [],
        call_status: data.call_status,
        branch: data.branch,
      }));

      setDetailItems(parsedItems[0]?.details || []);
      setAttachments(parsedAttachments);

    } catch (error) {
      console.error("FETCH ERROR:", error);
    }
  };



  const fetchCtype = async () => {

    try {
      const resCtype = await axios.get('https://api.skyguard.group/api/fetch-complaintype-master');
      // console.log(resCtype.data);
      const options = resCtype.data.map(ctype => ({
        value: ctype.id,
        label: ctype.name
      }));

      setComplaintList(options);

    } catch (error) {
      console.log(error)
    }
  }

  const fetchPartyDetail = async () => {
    try {
      const resParty = await axios.get("https://api.skyguard.group/api/fetch-party");
      const options = resParty.data.map((p) => ({
        value: p.id,
        label: p.name,
        phoneList: [
          p.phone,
          p.mobile,
          p.phone_two,
          p.phone_three,
          p.contact_no
        ].filter(Boolean),

        address: p.address || "",
      }));


      setPartyOptions(options);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchInventoryDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');

      const items = resInventory.data.result || [];

      const options = items.map(item => ({
        value: item.id,
        label: item.name,
        sr_no: item.sr_no,
        image: item.file,
      }));

      setInventoryOptions(options);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.items.length > 0) {
      setFormData(prev => ({ ...prev }));
    }
  }, [inventoryItems]);



  const fetchComplaints = async (fromDate,
    toDate,
    branchCode,
    newOffset = 0) => {

    if (!branchCode) {
      console.log("Branch code missing");
      return;
    }

    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-complaint",
        {
          params: {
            from_date: fromDate,
            to_date: toDate,
            branchId: branchCode,
            limit: limit,
            offset: newOffset
          }
        }
      );
      const complaints = res.data;


      const complaintsWithDetails = complaints.map(complaint => {
        const parsedItemDetails = JSON.parse(complaint.item_details || "[]");
        return { ...complaint, parsedItemDetails };
      });

      complaintsWithDetails.sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });



      // setCallList(complaintsWithDetails);

      const result = complaintsWithDetails;
      if (newOffset === 0) {
        setCallList(result);
        setHasMore(true);
      }

      else {
        setCallList(prev => {
          const merged = [...prev, ...result];

          // optional: remove duplicates (safety)
          const unique = Array.from(
            new Map(merged.map(item => [item.id, item])).values()
          );

          return unique;
        });
      }

      if (result.length < limit) {
        setHasMore(false);
      }

    } catch (err) {
      console.error(err);
    }
  };



  const fetchEmpDetail = async () => {
    setLoading(true)
    try {
      const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
      const employees = resEmployee.data.result || [];

      const options = employees
       .filter(emp => emp.emp_id !== null && emp.emp_id !== undefined && emp.emp_id !== "")
      .map(emp => ({
        value: emp.emp_id,
        label: `${emp.first} ${emp.middle || ""} ${emp.last} (${emp.emp_id})`,
        id: emp.id
      }));

      setEmployeeOptions(options);

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBranchDetail = async () => {
    setLoading(true)
    try {
      const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
      setBranchDetail(branchRes.data)

      return branchRes.data.code;
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };


  const fetchYearDetail = async () => {
    setLoading(true);
    try {
      const branchCode = await fetchBranchDetail();

      const res = await axios.get(
        `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
      );
      const yearData = res.data;
      setFy(yearData);
      setIsLocked(yearData.is_locked === 1);
      setFinancialRange({
        from_date: yearData.from_date,
        to_date: yearData.to_date
      });

      await fetchComplaints(
        yearData.from_date,
        yearData.to_date,
        branchCode,

      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  const fetchSerials = async (inventoryId, qty) => {
    if (!inventoryId) return;

    try {
      const res = await axios.get(
        "https://api.skyguard.group/api/fetch-inventory-serials",
        { params: { inventory_id: inventoryId } }
      );

      const flattened = Array.isArray(res.data[0]) ? res.data.flat() : res.data;
      const unsoldSerials = Array.from(
        new Map(flattened.map(s => [s.id, s])).values()
      ).filter(s => !s.sold_on || s.sold_on === 0);

      setSerialsByItem(prev => ({
        ...prev,
        [inventoryId]: unsoldSerials
      }));


      if (qty > unsoldSerials.length) {
        setSerialError(prev => ({
          ...prev,
          [inventoryId]: `Not enough serial numbers .`
        }));
      } else {
        setSerialError(prev => ({
          ...prev,
          [inventoryId]: null
        }));
      }
    } catch (err) {
      console.error("Error fetching serials:", err);
    }
  };


  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      // setLocation({ latitude, longitude });

      setLoading(false);
    },
    (err) => {
      console.error("Geolocation error:", err);
      setLoading(false);

    }
  );


  const fetchAddress = async ({ latitude, longitude }) => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
      );
      const data = await response.json();
      if (data && data.display_name) {
        setAddress(data.display_name);
        setLoading(false);
      } else {
        setAddress("Address not found");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setLoading(false);
    }
  };


  useEffect(() => {
    const savedSource = JSON.parse(localStorage.getItem("sourceOptions"));
    const savedStatus = JSON.parse(localStorage.getItem("statusOptions"));

    if (savedSource) setSourceOptions(savedSource);
    if (savedStatus) setStatusOptions(savedStatus);

    fetchCtype();
    fetchPartyDetail();
    fetchInventoryDetail();
    fetchComplaints(financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            0);
    fetchEmpDetail();
    fetchSerials();
    fetchBranchDetail();
    fetchYearDetail();

  }, []);



  const mapStatusToCallStatus = (status) => {
    if (!status) return "";

    if (status === "COMPLETED OC") return "completed";

    return status.toLowerCase();
  };


  const getRemarkText = (remarks) => {
    try {
      if (!remarks) return "";

      if (typeof remarks === "string" && remarks.trim().startsWith("{")) {
        const parsed = JSON.parse(remarks);
        return parsed?.remarks || "";
      }

      // If remarks is already an object
      if (typeof remarks === "object") {
        return remarks?.remarks || "";
      }

      // Plain string
      return remarks;
    } catch (err) {
      return "";
    }
  };
  useEffect(() => {
    if (formData.items) {
      setFormData(prev => ({
        ...prev,
        items:
          typeof prev.items === "string" ? JSON.parse(prev.items) : prev.items,
        item_details:
          typeof prev.item_details === "string"
            ? JSON.parse(prev.item_details)
            : prev.item_details
      }));
    }
  }, [formData.items]);


  const handleLoadMore = () => {

    const nextOffset = offset + limit;
    setOffset(nextOffset);

    fetchComplaints(
      financialRange.from_date,
      financialRange.to_date,
      branchDetail.code,
      nextOffset
    );
  };



  return (
    <>
      <div className='main-section'>
        <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
          <h3 className='my-3 fw-bold fs-5 golos'>Add Complaint</h3>
          <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
            <div className="col-12 col-md-5">
              <input
                type="text"
                className="form-control border-0 border-bottom border-dark"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-2 d-flex justify-content-end">
              <button className='btn btn-success' onClick={handleFormOpen}>
                <AiOutlinePlusCircle size={20} /> Add
              </button>
            </div>
          </div>
          {/* Form Section */}
          {showForm && (
            <div className="card p-3 my-3 shadow-sm bg-white border">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* left side */}
                  <div className="col-md-6">


                    {editId && (
                      <div className="mb-3">
                        <label>Document No:</label> <br />
                        <span className="badge bg-primary px-3 py-2">
                          {`CMP/${formData.id}/${formData.branch}`}
                        </span>
                      </div>
                    )}
                    <div className="row g-3">
                      {/*ComplaintType*/}
                      <div className="col-12">
                        <label className="form-label fw-medium">Complaint Type</label>
                        <Select
                          options={complaintList}
                          value={complaintList.find(option => option.value === formData.complaintType) || null}
                          onChange={(selectedOption) => {
                            setFormData(prev => ({
                              ...prev,
                              complaintType: selectedOption.value,
                              franchisee_cost:
                                selectedOption.label === "OC Call"
                                  ? 450
                                  : ""
                            }));
                          }}
                          placeholder="Select..."
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="party" className="form-label fw-medium">Ref Doc</label>
                        <Select

                          placeholder='Select Doc'
                        />
                      </div>

                      {/*Select Party*/}
                      <div className="col-12">
                        <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Choose Party..."
                          value={formData.party}
                          readOnly
                          onClick={() => setShowPartyModal(true)}
                          required
                          
                        />
                      </div>
                      {/*Site  */}
                      <div className="col-12">
                        <label htmlFor='site' className="form-label fw-medium">Site</label>
                        <input
                          type="text"
                          className="form-control"
                          name="site"
                          value={formData.site}
                          readOnly
                        />
                      </div>
                      {/* Contact Numbers */}
                      <div className='col-12'>
                        <label htmlFor='contact_no' className="form-label fw-medium"> Contact Numbers</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contact_no"
                          value={formData.contact_no}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>
                  {/* right-side */}
                  <div className='col-md-6'>
                    <div className='row g-3'>
                      {/* Franchisee Cost, date */}

                      <div className="col-12">
                        <div className='row g-2'>
                          <div className='col-md-6'>
                            <label htmlFor='date' className="form-label fw-medium"> Date</label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              name="date"
                              value={formData.date}
                              onChange={(e) =>
                                setFormData({ ...formData, date: e.target.value })
                              }
                              required
                            />
                          </div>
                          <div className='col-md-6'>
                            <label htmlFor='franchisee_cost' className="form-label fw-medium"> Franchisee Cost</label>
                            <input
                              type="number"
                              className="form-control"
                              name="franchisee_cost"
                              value={formData.franchisee_cost}
                              onChange={(e) =>
                                setFormData({ ...formData, franchisee_cost: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div>
                      {/* Description */}
                      <div className='col-12'>
                        <label htmlFor='description' className="form-label fw-medium">Description</label>
                        <textarea
                          className="form-control"
                          name="description"
                          value={formData.description}
                          onChange={(e) =>
                            setFormData({ ...formData, description: e.target.value })
                          }
                          placeholder="Enter here..."
                          rows="8"
                        />
                      </div>

                      <div className="col-12">
                        <div className='row g-2'>
                          <div className='col-md-6'>
                            <label htmlFor='date' className="form-label fw-medium">Repair Invoice</label><br />




                            <button
                              className="btn btn-success w-100"
                              onClick={() => {
                                const partyDataToSend = {
                                  partyid: formData.partyid,
                                  party: formData.party,
                                  site: formData.site,
                                  contact_no: formData.contact_no,
                                };

                                console.log("Sending partyData:", partyDataToSend);

                                navigate("/admin/repair-invoice", {
                                  state: {
                                    showForm: true,
                                    partyData: partyDataToSend
                                  }
                                });
                              }}
                            >
                              Click Here
                            </button>
                          </div>


                          <div className='col-md-6'>
                            <label htmlFor='date' className="form-label fw-medium">AMC</label> <br />
                            <button className='btn btn-success w-100'
                              onClick={() => {
                                const partyDataToSend = {
                                  partyid: formData.partyid,
                                  party: formData.party,
                                  site: formData.site,
                                  contact_no: formData.contact_no,
                                  address: formData.site
                                };

                                console.log("Sending partyData:", partyDataToSend);

                                navigate("/admin/amc", {
                                  state: {
                                    showForm: true,
                                    partyData: partyDataToSend
                                  }
                                });
                              }}
                            >
                              Click Here
                            </button>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                  <div className="table-responsive my-4">
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="btn btn-primary btn-sm col-md-1"
                        onClick={addRow}
                      >
                        + Add Item
                      </button>
                    </div>
                    <table className="table table-bordered mx-auto text-center align-middle w-75">
                      <thead className="table-primary">
                        <tr>
                          <th>Model</th>
                          <th>Item QTY</th>
                          <th>Installed In</th>
                          {/* <th>Sr No </th> */}
                          <th>Details</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>


                        {(formData.items || []).map((row, index) => (
                          <tr key={index}>
                            <td style={{ minWidth: "250px" }}>

                              <Select
                                options={inventoryOptions}
                                value={
                                  inventoryOptions.find(opt => opt.value === row.item) || null
                                }
                                onChange={(selected) =>
                                  updateItemRow(index, "item", selected.value)
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                required
                              />


                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                value={row.qty}
                                onChange={(e) =>
                                  updateItemRow(index, "qty", e.target.value)
                                }

                              />
                            </td>


                            <td>
                              <input
                                type="text"
                                className="form-control"
                                value={row.install}
                                onChange={(e) => updateItemRow(index, "install", e.target.value)}
                              />
                            </td>


                            <td>


                              <button
                                type="button"
                                className="btn btn-success btn-sm m-1"
                                onClick={() => {
                                  setSelectedItemIndex(index);
                                  setDetailItems(row.details);
                                  setShowDetailModal(true);
                                }}
                              >
                                Detail
                              </button>




                              <button
                                type="button"
                                className="btn btn-primary btn-sm m-1"
                                onClick={handleOpenHistory}
                              >
                                History
                              </button>



                              <button
                                type="button"
                                className="btn btn-secondary btn-sm m-1"
                                onClick={() => {
                                  const inventoryItem = inventoryOptions.find(
                                    opt => opt.value === row.item
                                  );

                                  if (inventoryItem && inventoryItem.image) {
                                    let imagesArray = [];

                                    try {
                                      imagesArray = JSON.parse(inventoryItem.image);
                                    } catch (err) {
                                      console.error("Error parsing image JSON:", err);
                                    }


                                    if (imagesArray.length > 0) {
                                      setSelectedImage(imagesArray);
                                      setShowImageModal(true);
                                    } else {
                                      alert("No image available for this item");
                                    }
                                  } else {
                                    alert("No image available for this item");
                                  }
                                }}
                              >
                                View Image
                              </button>

                            </td>

                            <td>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => {
                                  const newItems = (formData.items || []).filter((_, i) => i !== index);
                                  setFormData(prev => ({ ...prev, items: newItems }));
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="row g-3">
                    {/* Remarks */}
                    <div className='col-12'>
                      <label htmlFor='remark' className="form-label fw-medium">Remarks</label>
                      <textarea
                        className="form-control"
                        name="remarks"
                        id="remarks"
                        placeholder="Enter here..."
                        rows="6"
                        value={newRemark}
                        onChange={(e) => setNewRemark(e.target.value)}
                        required
                      />
                    </div>


                    <div className="col-12 mt-3">

                      <div className="d-flex justify-content-end mb-2">
                        <button
                          type="button"
                          className="btn btn-success btn-sm"
                          onClick={addVisitRow}
                        >
                          + Add Visit
                        </button>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-bordered text-center align-middle w-100 " >
                          <thead className="table-dark">
                            <tr>
                              <th>Technician Name</th>
                              <th>Assigned Date Time</th>
                              <th>Visit Date Time</th>
                              <th>Visit Out Date Time</th>
                              <th>In Location</th>
                              <th>Out Location</th>
                              <th>Remark</th>
                              <th>Status</th>

                            </tr>
                          </thead>

                          <tbody key={editId || "new"}>
                            {formData?.visits?.map((row, index) => (
                              <tr key={index}>
                                <td className="col-2">
                                  <Select
                                    menuPortalTarget={document.body}
                                    styles={{ container: base => ({ ...base, width: "100%" }) }}
                                    options={employeeOptions}
                                    value={row.technician || null}
                                    onChange={(selected) =>
                                      updateVisitRow(index, "technician", selected)
                                    }
                                  />
                                </td>

                                <td className="col-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={row.assignedDate}
                                    onChange={e => updateVisitRow(index, "assignedDate", e.target.value)}
                                  />
                                </td>

                                <td className="col-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={row.visitDate}
                                    onChange={e => updateVisitRow(index, "visitDate", e.target.value)}
                                  />
                                </td>
                                <td className="col-2">
                                  <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={row.visitOutDate}
                                    onChange={e => updateVisitRow(index, "visitOutDate", e.target.value)}
                                  />
                                </td>

                                <td className="col-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={row.inLocation}
                                    onChange={e => updateVisitRow(index, "inLocation", e.target.value)}
                                  />
                                </td>
                                <td className="col-2">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={row.outLocation}
                                    onChange={e => updateVisitRow(index, "outLocation", e.target.value)}
                                  />
                                </td>


                                <td className="col-2">
                                  <div className="d-flex gap-2">
                                    {/* <input
                                   type="text"
                                      className="form-control"
                                      value={row.remark}
                                     onChange={e => updateVisitRow(index, "remark", e.target.value)}
                                      /> */}

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary"
                                      onClick={() => {
                                        setPreviewRemark(row.remark);
                                        setShowPreview(true);
                                      }}
                                    >
                                      Preview
                                    </button>
                                  </div>
                                </td>




                                <td className="col-2" >
                                  <div style={{ minWidth: 150 }}>
                                    <Select
                                      options={statusOptions}
                                      value={row.status}
                                      onChange={val => updateVisitRow(index, "status", val)}
                                      styles={{
                                        container: base => ({ ...base, width: "100%" }),
                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                      }}
                                      menuPortalTarget={document.body}
                                      isDisabled={row.status?.value === "RE-COMPLAINT"}
                                    />
                                  </div>

                                </td>
                              </tr>
                            ))}
                          </tbody>


                        </table>
                      </div>
                    </div>
                    <div className='col-12'>
                      <label htmlFor='remark' className="form-label fw-medium">Remarks/Customer Feedback</label>
                      <textarea
                        className="form-control"
                        name="customer_remark"
                        id="remarks"
                        placeholder="Enter here..."
                        rows="6"
                        value={formData.customer_remark}
                        onChange={(e) =>
                          setFormData({ ...formData, customer_remark: e.target.value })
                        }
                      />
                    </div>


                    {/* left side */}
                    <div className="col-md-6">
                      {/* Source, Status */}
                      <div className="col-12">
                        <div className='row g-2'>
                          <div className='col-md-12 d-flex align-items-center'>
                            <div className="flex-grow-1">
                              <label className="form-label fw-medium">Select Source</label>
                              <Select
                                options={sourceOptions}
                                value={
                                  sourceOptions.find(
                                    opt => opt.value.toLowerCase() === String(formData.source || "").toLowerCase()
                                  ) || null
                                }
                                onChange={(selected) =>
                                  setFormData({ ...formData, source: selected.value })
                                }
                              />

                            </div>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary ms-2 mt-4"
                              onClick={() => {
                                setActiveDropdown("source");
                                setNewOptionValue("");
                                setShowOptionModal(true);
                              }}
                            >
                              + Add
                            </button>
                          </div>


                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>

                      <div className='col-md-12 d-flex align-items-center'>
                        <div className="flex-grow-1">
                          <label className="form-label fw-medium">Select Status</label>

                          <Select
                            options={statusOptions}
                            // value={
                            //   statusOptions.find(
                            //     opt =>
                            //       opt.value.toLowerCase() ===
                            //       String(formData.status || "").toLowerCase()
                            //   ) || null
                            // }

                            value={
                              statusOptions.find(
                                opt => opt.value === formData.status
                              ) || null
                            }
                            onChange={(selected) => {
                              const statusValue = selected.value;

                              setFormData({
                                ...formData,
                                status: statusValue,
                                // call_status: mapStatusToCallStatus(statusValue)
                              });
                            }}
                          />

                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary ms-2 mt-4"
                          onClick={() => {
                            setActiveDropdown("status");
                            setNewOptionValue("");
                            setShowOptionModal(true);
                          }}
                        >
                          + Add
                        </button>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="col-md-12">
                        <label className="form-label fw-medium">Upload Attachments</label>

                        <input
                          type="file"
                          className="form-control"
                          multiple
                          ref={fileInputRef}
                          onChange={(e) => {
                            const newFiles = Array.from(e.target.files).map(file => ({
                              file,
                              remark: ""
                            }));
                            setAttachments(prev => [...prev, ...newFiles]);
                            fileInputRef.current.value = "";
                          }}
                        />
                      </div>

                      {/* Beautiful list */}
                      {attachments.length > 0 && (
                        <div className="mt-3">
                          <label className="fw-medium d-block mb-2">Attached Files</label>

                          <div className="list-group shadow-sm">
                            {attachments.map((att, idx) => (
                              <div key={idx} className="list-group-item">

                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center">
                                    <span className="badge bg-primary me-2">{idx + 1}</span>
                                    <span>{att.file?.name || att.file_name}</span>

                                  </div>

                                  <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => {
                                      const updated = attachments.filter((_, i) => i !== idx);
                                      setAttachments(updated);
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>

                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  placeholder="Add remark..."
                                  value={att.remark || ""}
                                  onChange={(e) => {
                                    const updated = [...attachments];
                                    updated[idx].remark = e.target.value;
                                    setAttachments(updated);
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-12 mt-2' >
                    <h3 className='text-primary'>Remark History </h3>
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle w-100 " >
                        <thead className="table-info">
                          <tr>
                            <th >Employee Name</th>
                            <th >Remark Date </th>

                            <th >Remark</th>


                          </tr>
                        </thead>
                        <tbody>
                          {remarkTableData.length > 0 ? (
                            remarkTableData.map((row, index) => (
                              <tr key={index}>
                                <td>{row.adminName}  </td>

                                <td>
                                  {row.date ? new Date(row.date).toLocaleString() : "-"}
                                </td>

                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    data-bs-toggle="modal"
                                    data-bs-target="#remarkModal"
                                    onClick={() => setSelectedRemark(row.remark)}
                                  >
                                    View
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-muted text-center">
                                No remark history found
                              </td>
                            </tr>
                          )}


                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
                {/* save/Cancel */}
                <div className='d-flex justify-content-center mt-5 gap-2'>
                  <button type='submit' className='btn btn-success'>
                    {editId ? "UPDATE" : "SAVE"}
                  </button>
                  <button
                    type='button'
                    className='btn btn-danger'
                    onClick={resetForm}
                  >
                    Cancel
                  </button>

                </div>
              </form>
            </div>
          )}
          <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            <table className='table table-bordered table-striped text-center table-sm align-middle'>
              <thead className='table-info'>
                <tr>
                  <th>SN</th>
                  <th>Ref Doc</th>
                  <th>Action</th>
                  <th>Complaint Type</th>
                  <th>Party</th>
                  <th>Contact No</th>
                  <th>Status</th>
                  <th>Enterd By</th>
                  <th>Entered Date</th>
                  <th>Updated By </th>
                  <th>Updated On </th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((complaint, index) => (
                    <tr key={index}>
                      <td>{filteredData.length - index} </td>

                      <td>{`CMP/${complaint.ref_doc}/${complaint.branch}/${fy.financial_year.split('-')[0]}`}</td>

                      <td
                        className="cursor-pointer"
                        style={{ display: "flex", alignItems: "center", justifyContent: 'space-around' }}
                      >
                        {/* Edit icon */}
                        <CiEdit
                          size={26}
                          onClick={() => handleEdit(complaint)}
                          style={{ cursor: "pointer" }}
                          title="Edit Complaint"
                        />

                        {/* Print icon */}
                        <MdLocalPrintshop
                          size={26}
                          className="ms-3 text-primary"
                          onClick={() => handlePrint(complaint)}
                          style={{ cursor: "pointer" }}
                          title="Print Complaint"
                        />
                      </td>

                      <td>{complaint.complaint_name}</td>
                      <td>{complaint.party_name}</td>


                      <td>
                        {[
                          complaint.party_phone,
                          complaint.party_phone2,
                          complaint.party_phone3,
                          complaint.party_phone4
                        ]
                          .filter(Boolean)
                          .join(", ")
                          .slice(0, 20) +
                          ([
                            complaint.party_phone,
                            complaint.party_phone2,
                            complaint.party_phone3,
                            complaint.party_phone4
                          ].filter(Boolean).join(", ").length > 20
                            ? "..."
                            : ""
                          )
                        }
                      </td>
                      <td>{complaint.status}</td>
                      <td>{complaint.added_name} {complaint.added_name_middle} {complaint.added_name_last} </td>

                      <td>{new Date(complaint.date).toLocaleString()}</td>

                      <td>{complaint.edit_name} {complaint.edit_name_middle} {complaint.edit_name_last} </td>
                      <td>{complaint.edit_date} </td>


                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10">No data found</td>
                  </tr>
                )}
              </tbody>
            </table>

       
            {selectedPrint && (
              <div id="print-area" style={{ display: "none" }}>
                <div
                  style={{
                    padding: "40px",
                    fontFamily: "Arial, sans-serif",
                    width: "800px",
                    margin: "auto",
                    lineHeight: "1.6"
                  }}
                >
                  {/* HEADER */}
                  <div style={{ textAlign: "center", marginBottom: "20px" }} className='bg-danger'>
                    <img
                      src={logo}
                      alt="Company Logo"
                      style={{ width: "120px", marginBottom: "10px" }}
                    />
                    <h2 style={{ margin: 0, fontSize: "24px" }}>SKY GUARD</h2>
                    <p style={{ margin: 0, fontSize: "14px", color: "#555" }}>
                      Complaint Report
                    </p>
                  </div>

                  <hr style={{ borderTop: "2px solid #000", margin: "20px 0" }} />

                  {/* COMPLAINT INFORMATION */}
                  <h3 style={{ fontSize: "18px", marginBottom: "8px" }}>Complaint Details</h3>

                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px"
                    }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ width: "30%", fontWeight: "bold", padding: "6px" }}>
                          Complaint Type:
                        </td>
                        <td style={{ padding: "6px" }}>{selectedPrint.complaint_name}</td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Party:</td>
                        <td style={{ padding: "6px" }}>{selectedPrint.party_name}</td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Site:</td>
                        <td style={{ padding: "6px" }}>{selectedPrint.party_address}</td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Contact No:</td>
                        <td style={{ padding: "6px" }}>
                          {[
                            selectedPrint.party_phone,
                            selectedPrint.party_phone2,
                            selectedPrint.party_phone3,
                            selectedPrint.party_phone4
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Date:</td>
                        <td style={{ padding: "6px" }}>
                          {new Date(selectedPrint.date).toLocaleString()}
                        </td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Status:</td>
                        <td style={{ padding: "6px" }}>{selectedPrint.status}</td>
                      </tr>

                      <tr>
                        <td style={{ fontWeight: "bold", padding: "6px" }}>Source:</td>
                        <td style={{ padding: "6px" }}>{selectedPrint.source}</td>
                      </tr>

                      <tr>
                        <td style={{ verticalAlign: "top", fontWeight: "bold", padding: "6px" }}>
                          Remarks:
                        </td>
                        <td style={{ padding: "6px" }}>{getRemarkText(selectedPrint.remarks)}</td>
                      </tr>
                    </tbody>
                  </table>

                  {/* ITEMS TABLE */}
                  <h3 style={{ fontSize: "18px", marginBottom: "10px" }}>Item Details</h3>

                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      marginBottom: "20px",
                      border: "1px solid #ccc"
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            background: "#f5f5f5",
                            width: "60%"
                          }}
                        >
                          Item Name
                        </th>
                        <th
                          style={{
                            border: "1px solid #ccc",
                            padding: "8px",
                            background: "#f5f5f5"
                          }}
                        >
                          Installed In
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {JSON.parse(selectedPrint.items).map((item, i) => (
                        <tr key={i}>
                          <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                            {item.name}
                          </td>
                          <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                            {item.install}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* SIGNATURE */}
                  <div style={{ marginTop: "40px", textAlign: "right" }}>
                    <p style={{ marginBottom: "60px" }}>__________________________</p>
                    <p style={{ fontWeight: "bold" }}>Authorized Signature</p>
                  </div>
                </div>
              </div>
            )}

            {hasMore && (
              <div className="text-center mt-3">
                <button
                  className="btn btn-primary"
                  onClick={handleLoadMore}
                >
                  Load More
                </button>
              </div>
            )}


          </div>

        </div>
      </div>

      {/* Inline Modal */}
      <Modal
        show={showPartyModal}
        onHide={() => setShowPartyModal(false)}
        size="lg"
        centered
        dialogClassName="party-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">🔍 Search Party</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          {/* Search Bar */}
          <div className="mb-3">
            <Form.Control
              type="text"
              className="search-box"
              placeholder="Search party by name, phone, or address..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
                   ref={searchInputRef}
            />
          </div>

          {/* Responsive Table */}
          <div className="table-responsive">
            <Table hover className="party-table">
              <thead>
                <tr>
                    <th className="text-center">Action</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Address</th>
                
                </tr>
              </thead>

              <tbody>
                {filtered.map((p) => (
                  <tr key={p.value} className="row-hover">
                        {/* SELECT BUTTON */}
                    <td className="text-center">
                      <Button
                        className="select-btn"
                        onClick={() => {
                          const fullAddress = `${p.label}, ${p.address}`;
                          const allPhones = p.phoneList.join(", ");

                          setFormData(prev => ({
                            ...prev,
                            partyid: p.value,
                            party: p.label,
                            site: fullAddress,
                            contact_no: allPhones,
                          }));

                          setShowPartyModal(false);
                        }}
                      >
                        Select
                      </Button>
                    </td>
                    <td>{p.label}</td>

                    {/* PHONE  */}
                    <td
                      className="truncate"
                      title={p.phoneList.join(", ")}
                    >
                      {limitText(p.phoneList.join(", "), 20)}
                    </td>

                    {/* ADDRESS  */}
                    <td
                      className="truncate"
                      title={p.address}
                    >
                      {limitText(p.address, 30)}
                    </td>


                
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>


      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <Modal
        show={showOptionModal}
        onHide={() => setShowOptionModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New {activeDropdown === "source" ? "Source" : "Status"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder={`Enter new ${activeDropdown}`}
            value={newOptionValue}
            onChange={(e) => setNewOptionValue(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowOptionModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              if (!newOptionValue.trim()) return;

              const newOption = {
                value: newOptionValue.trim(),
                label: newOptionValue.trim()
              };


              if (activeDropdown === "source") {
                const updatedOptions = [...sourceOptions, newOption];

                localStorage.setItem("sourceOptions", JSON.stringify(updatedOptions));
                setSourceOptions(updatedOptions);
                setFormData(prev => ({ ...prev, source: newOption.value }));
              }

              if (activeDropdown === "status") {
                const updatedOptions = [...statusOptions, newOption];

                localStorage.setItem("statusOptions", JSON.stringify(updatedOptions));
                setStatusOptions(updatedOptions);
                setFormData(prev => ({ ...prev, status: newOption.value }));
              }


              setShowOptionModal(false);
              setNewOptionValue("");
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>


      {/* item detail  */}
      <Modal
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Item Details</Modal.Title>



        </Modal.Header>

        <Modal.Body>

          <div className="d-flex justify-content-start mb-2">

          </div>
          <div className="table-responsive">
            <table className="table table-bordered text-center align-middle" style={{ tableLayout: "fixed" }}>
              <thead className="table-dark">
                <tr>

                  <th>Item Name</th>
                  <th>Quantity</th>
                  <th>Sr No</th>
                  <th>Technician</th>

                </tr>
              </thead>
              <tbody>
                {detailItems.map((row, index) => (
                  <tr key={index}>
                    <td>{row.item_name}</td>
                    <td>{row.quantity}</td>
                    <td>{Array.isArray(row.sr_no) ? row.sr_no.join(", ") : row.sr_no}</td>
                    <td>{row.technician || "-"}</td>

                  </tr>
                ))}
              </tbody>

            </table>
          </div>


        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDetailModal(false)}
          >
            Close
          </button>



        </Modal.Footer>
      </Modal>


      {/* techinician history*/}
      <Modal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Technician History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loadingHistory ? (
            <div className="text-center">Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered text-center align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>Model Name</th>
                    <th>Tehnician</th>
                    <th>Done On</th>


                    <th>Sub Part </th>
                    <th>Qty </th>
                    <th>Sr No</th>

                  </tr>
                </thead>
                <tbody>
                  {historyItems.length === 0 ? (
                    <tr>
                      <td colSpan="5">No history found</td>
                    </tr>
                  ) : (
                    historyItems.map((row, index) => (
                      <tr key={index}>
                        <td>{row.model_name}</td>
                        <td>{row.technician}</td>
                        <td>{row.date}</td>
                        <td>{row.sub_item} </td>
                        <td>{row.quantity}</td>
                        <td>{row.sr_no}</td>
                      </tr>

                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowHistoryModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Item Images</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <div className="row">
            {selectedImage.map((img, index) => (
              <div className="col-md-3 mb-3" key={index}>
                <div className="card">
                  <img
                    src={`https://api.skyguard.group/uploads/${img.filename}`}
                    className="card-img-top"
                    alt="Item"
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center p-2">
                    <span
                      style={{
                        display: "inline-block",
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        backgroundColor: img.color
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowImageModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRemarkModal}
        onHide={() => setShowRemarkModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Remark</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p style={{ whiteSpace: "pre-wrap" }}>
            {selectedRemark || "No remark available"}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowRemarkModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <div
        className="modal fade"
        id="remarkModal"
        tabIndex="-1"
        aria-labelledby="remarkModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title" id="remarkModalLabel">
                Remark
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <p style={{ whiteSpace: "pre-wrap" }}>
                {selectedRemark || "No remark available"}
              </p>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>

          </div>
        </div>
      </div>



      {showPreview && (
        <div className="modal show d-block mt-8" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Remark Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPreview(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>{previewRemark || "No remark entered"}</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowPreview(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



    </>
  )
}

export default Complaint